import { render, staticRenderFns } from "./SimulacaoCalculoFrete.vue?vue&type=template&id=59b70bca"
import script from "./SimulacaoCalculoFrete.vue?vue&type=script&lang=js"
export * from "./SimulacaoCalculoFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports